// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"72caf9fb","18":"368b9301","50":"d82a9d64","300":"fd936cb9","339":"4a5f01c7","392":"af40f3ec","447":"a79af8c9","522":"a8c388e2","587":"454e534e","636":"8cb87306","710":"21e471fb","787":"153f4496","847":"e7aacc97","942":"523c0177","954":"814cc162"}[chunkId] + ".chunk.js";
};